/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

export function setLocalStorage(name, data) {
  window.localStorage.setItem(name, JSON.stringify(data))
}
export function getLocalStorage(name) {
  return JSON.parse(window.localStorage.getItem(name))
}
export function removeLocalStorage(name) {
  window.localStorage.removeItem(name)
}
// 数组去重
export function unique1(arr) {
  const currentAttr = []
  for (let i = 0; i < arr.length; i++) {
    if (currentAttr.indexOf(arr[i]) === -1) {
      currentAttr.push(arr[i])
    }
  }
  return currentAttr
}

// 判断是否为小数
export function isDecimal(data) {
  const newArray = data.toString().split('.')
  return newArray.length > 1
}

// 复制内容到剪切板
export function copyUrl(text) {
  const Url = document.createElement('INPUT')
  Url.type = 'text'
  document.body.appendChild(Url)

  Url.value = text
  Url.select() // 选择对象
  const result = document.execCommand('Copy') // 执行浏览器复制命令
  document.body.removeChild(Url)
  // alert('5')
  return result
}

// 日期加0
export function getParm(i) {
  if (i < 10) {
    i = '0' + i
  }
  return i
}
// 日期转换为 年-月-日
export function dateTransform(date) {
  const putStartTime = new Date(date) // 开始时间
  const result = putStartTime.getFullYear() + '-' + getParm(putStartTime.getMonth() + 1) + '-' + getParm(putStartTime.getDate())
  return result
}
// 货币格式转换
// 制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimal2(money) {
  if (money && money != null) {
    money = String(money)
    var left = money.split('.')[0]
    var right = money.split('.')[1]
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
    return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right
  } else if (money === 0) {
    return '0.00'
  } else {
    return false
  }
}
